<template>

    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="type === 0 ? '修改功能' : '功能详情'"
        :visible.sync="visible"
        width="35%"
        @close="closeDialog"
        @open="openDialog">

        <el-form :model="form" size="small" :rules="rules" ref="ruleForm" class="effect_form"
                 :label-width="formLabelWidth" v-if="type === 0">

            <el-form-item label="功能名称：" prop="effectName">
                <el-input
                    v-model.trim="form.effectName"
                    placeholder="请输入功能名称">
                </el-input>
            </el-form-item>

            <el-form-item label="功能标识：" prop="effectRemarks">
                <el-input
                    v-model.trim="form.effectRemarks"
                    :disabled="form.effectType === 1"
                    placeholder="请输入功能标识">
                </el-input>
            </el-form-item>

            <el-form-item label="权限：" prop="authority">
                <el-radio-group v-model="form.authority" :disabled="form.effectType === 1">
                    <el-radio :label="item1.id" v-for="(item1,index1) in $message.authorityList" :key="index1">
                        {{ item1.name }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="备注：">
                <el-input
                    type="textarea"
                    :disabled="form.effectType === 1"
                    v-model="form.remark"
                    :rows="4"
                    show-word-limit
                    maxlength="200"
                    placeholder="请输入备注">
                </el-input>
            </el-form-item>

        </el-form>

        <el-form :model="form" size="small" :rules="rules" ref="ruleForm" class="effect_form"
                 :label-width="formLabelWidth" v-else>
            <el-form-item label="功能名称：">{{ form.effectName }}</el-form-item>
            <el-form-item label="功能标识：">{{ form.effectRemarks }}</el-form-item>
            <el-form-item label="权限：">{{ $config.getMsgItemUtil($message.authorityList, form.authority, 'id', 'name') }}</el-form-item>
            <el-form-item label="备注：">{{ form.remark }}</el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="submit" v-if="type === 0">确 认</el-button>
        </span>

    </el-dialog>

</template>

<script>

import {mapState, mapActions} from "vuex";

export default {

    computed: {
        ...mapState('effect', ['modifyEffectDialogVisible', 'effectListItem', 'effectDialogType'])
    },

    watch: {

        modifyEffectDialogVisible: {
            handler(newVal) {
                this.visible = newVal;
            }
        },

        effectListItem: {
            handler(newVal) {
                this.form = {
                    code: newVal.code,
                    effectName: newVal.effectName,
                    effectRemarks: newVal.effectRemarks,
                    effectType: newVal.effectType,
                    authority: newVal.authority,
                    remark: newVal.remark
                }
            },
            deep: true
        },

        effectDialogType: {
            handler(newVal) {
                this.type = newVal;
            }
        }

    },

    data() {

        return {

            formLabelWidth: "100px",

            visible: false,

            loading: false,

            type: 0,

            form: {
                code: "",
                effectName: "",
                effectRemarks: "",
                remark: "",
                authority: ""
            },

            rules: {
                effectName: [
                    {required: true, message: "请输入功能名称", trigger: "blur"},
                    {pattern: /^(?=[\S\s]{1,20}$)[\S\s]*/, message: '输入不能超过20个字符'},
                ],
                authority: [{required: true, message: "请选择权限", trigger: "blur"}],
                effectRemarks: [
                    {required: true, message: "请输入功能标识", trigger: "blur"},
                    {pattern: /^(?=[\S\s]{1,32}$)[\S\s]*/, message: '输入不能超过32个字符'},
                    {pattern: /^[a-z_0-9]*$/, message: '只能输入小写字母、下划线及数字'},
                ],
            }

        }

    },

    methods: {

        ...mapActions('effect', ['modifyProductService', 'closeModifyEffectDialog']),

        closeDialog() {
            this.closeModifyEffectDialog();
            this.$refs['ruleForm'].resetFields();
        },

        openDialog() {
            this.type = this.effectDialogType;
        },

        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.modifyProductService({
                        authority: this.form.authority,
                        name: this.form.effectName,
                        serviceCode: this.form.code,
                        serviceKey: this.form.effectRemarks,
                        productCode: this.$route.query.id,
                        remark: this.form.remark
                    }).then(res => {
                        this.loading = false;
                        this.$dialog.showMessage("修改成功", this.$config.TOAST_SUCCESS);
                        this.$emit("getMsg");
                        this.closeDialog();
                    }, err => {
                        this.loading = false;
                        this.$dialog.showMessage(err.resultMsg, this.$config.TOAST_ERROR);
                    })
                }
            })
        }

    }

}

</script>

<style scoped>

.effect_form {
    margin-top: 20px;
}

/deep/ .el-dialog {
    text-align: left !important;
}

/deep/ .el-dialog--center .el-dialog__footer {
    text-align: right !important;
}

/deep/ .el-dialog__body {
    padding-top: 0;
}

/deep/ .el-dialog__title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}

/deep/ .el-dialog__header {
    border-bottom: 1px solid #E9E9E9;
    padding: 13px;
}
</style>
